import { render, staticRenderFns } from "./VatPreviewTable.vue?vue&type=template&id=21182724&scoped=true"
import script from "./VatPreviewTable.vue?vue&type=script&lang=js"
export * from "./VatPreviewTable.vue?vue&type=script&lang=js"
import style0 from "./VatPreviewTable.vue?vue&type=style&index=0&id=21182724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21182724",
  null
  
)

export default component.exports